import { InvitationResponse } from "./types";

interface InvitationInfoCardProps {
  agreement: InvitationResponse["agreement"];
}

export function InvitationInfoCard({ agreement }: InvitationInfoCardProps) {
  return (
    <div className="p-6 border border-gray-200 dark:border-gray-700 rounded-lg">
      <h3 className="text-lg font-semibold text-foreground mb-4">
        Информация о приглашении
      </h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <span className="text-sm text-gray-500">Бизнес-профиль</span>
          <p className="font-medium">
            {agreement.business_profile_name || "Не указано"}
          </p>
        </div>
        <div>
          <span className="text-sm text-gray-500">Офис</span>
          <p className="font-medium">{agreement.office_name || "Не указано"}</p>
        </div>
        <div className="md:col-span-2">
          <span className="text-sm text-gray-500">Адрес</span>
          <p className="font-medium">
            {agreement.location_address || "Не указано"}
          </p>
        </div>
        <div>
          <span className="text-sm text-gray-500">Цена</span>
          <p className="font-medium">{agreement.price || "Не указано"} ₽</p>
        </div>
        <div>
          <span className="text-sm text-gray-500">Дата начала</span>
          <p className="font-medium">
            {agreement.start_date
              ? new Date(agreement.start_date).toLocaleDateString("ru-RU")
              : "Не указано"}
          </p>
        </div>
        <div>
          <span className="text-sm text-gray-500">Дата окончания</span>
          <p className="font-medium">
            {agreement.end_date
              ? new Date(agreement.end_date).toLocaleDateString("ru-RU")
              : "Не указано"}
          </p>
        </div>
      </div>
    </div>
  );
}
